import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { WittigCredentialsInputDTORuntype, WittigResponseBodyDTORuntype } from './wittigBackendTypes';

export const wittigEndpoints = {
    'GET /3rdparty/wittig/credentials': endpoint({
        description: 'Returns credentials for Wittig integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: WittigResponseBodyDTORuntype,
    }),
    'POST /3rdparty/wittig/credentials': endpoint({
        description: 'Uploads credentials for Wittig API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: WittigCredentialsInputDTORuntype,
        responseBody: WittigResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/wittig/credentials'],
    }),
    'PATCH /3rdparty/wittig/credentials': endpoint({
        description: 'Updates credentials for Wittig API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: WittigCredentialsInputDTORuntype,
        responseBody: WittigResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/wittig/credentials'],
    }),
    'DELETE /3rdparty/wittig/credentials': endpoint({
        description: 'Deletes existing credentials for Wittig API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/wittig/credentials'],
    }),
};
